import { AuxiliumComponent } from "../auxilium-component";

export default class SortableListItem extends AuxiliumComponent {
}
